import { BaseDto } from '../base.dto';
import { InvoiceBillingDto } from './invoice-billing.dto';
import { DispatchStatus } from '../../enum';

export class InvoiceBillingDispatchLogDto extends BaseDto {
  invoiceBillingId: number;
  status: DispatchStatus;
  retryCount: number;
  errorMessage: string | null;
  lastAttemptTimestamp: Date | null;
  invoiceBilling: InvoiceBillingDto;
}